export const chatConstants = {
  SET_CHAT_ROOM_PARAMS_SUCCESS: 'SET_CHAT_ROOM_PARAMS_SUCCESS',
  SET_CHAT_ROOM_PARAMS_FAILURE: 'SET_CHAT_ROOM_PARAMS_FAILURE',
};
